import { ViewId } from '~/shared/utils';
import { useIntl } from 'react-intl';
import { CaptionButton } from '~/shared/components/ui/Button';
import { GetMessageWithIntl } from '~/shared/components';

import { getGenerallyIconElement } from '~/shared/components/parts/Button/GenerallyIcons';

interface GuidancePanelItemProps {
  type?: string;
}

interface GuidancePanelFooterProps {
  onToConfirm: () => void;
}

const VIEW_ID: ViewId = 'OCP_PR_INPUT';
export const GuidancePanelItem = ({ type }: GuidancePanelItemProps) => {
  const intl = useIntl();
  return (
    <>
      <div className="tab-info-body">
        <div className="description-area">
          <p className="title">
            {getGenerallyIconElement('unchecked')}
            自社企業紹介の作成
          </p>
          <p className="text-box">
            <span className="text">
              企業紹介ページを完成させるために、4つのステップで登録を進めてください。
              <br />
              公開済みの自社企業紹介ページの確認を行う場合も、確認へ進むボタンをクリックしてください。
            </span>
          </p>
        </div>

        <div className="guidance-item">
          <div className="guidance-title">1</div>
          <div className="guidance-contents">
            <h3 className="guidance-contents-title">確認</h3>
            <p className="guidance-contents-description">
              現在の登録情報を確認します。
              <br />
              初回の場合は、自社企業情報より自動生成したサンプル文章を初期表示します。必ず確認し、編集してください。
              <br />
              画面は他企業が参照する企業紹介ページと同レイアウトになっています。
            </p>
          </div>
        </div>
        <div className="guidance-item">
          <div className="guidance-arrow">↓</div>
        </div>

        <div className="guidance-item">
          <div className="guidance-title">2</div>
          <div className="guidance-contents">
            <h3 className="guidance-contents-title">AIアシスト編集</h3>
            ※スキップ可能
            <p className="guidance-contents-description">
              AI生成機能を活用して、サンプル文章を調整します。
              <br />
              最新の自社企業情報から生成します。
            </p>
          </div>
        </div>
        <div className="guidance-item">
          <div className="guidance-arrow">↓</div>
        </div>
        <div className="guidance-item">
          <div className="guidance-title">3</div>
          <div className="guidance-contents">
            <h3 className="guidance-contents-title">編集</h3>
            <p className="guidance-contents-description">手動で修正します。</p>
          </div>
        </div>
        <div className="guidance-item">
          <div className="guidance-arrow">↓</div>
        </div>
        <div className="guidance-item">
          <div className="guidance-title">4</div>
          <div className="guidance-contents">
            <h3 className="guidance-contents-title">公開前確認</h3>
            <p className="guidance-contents-description">
              公開前の企業紹介ページの内容を最終確認します。
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export const GuidancePanelFooterItem = ({
  onToConfirm,
}: GuidancePanelFooterProps) => {
  const intl = useIntl();
  return (
    <>
      <CaptionButton
        name="resetBtn"
        caption={GetMessageWithIntl(intl, {
          prefixId: VIEW_ID,
          id: 'toConfirm',
        })}
        className="btn"
        onClick={onToConfirm}
        buttonType="basic"
      />
    </>
  );
};
